import { PDFDocument, rgb, StandardFonts} from 'pdf-lib';
import { inicializarIndicesSeguro, calcularValoresSeguro } from '../utils/seguroUtils';
import { getEmpresaAtual } from './api';
import {
  coresHex, hexParaRgb,
} from '../styles/styleUtils';

// Converte um hex de coresHex em rgb() 0-1 do pdf-lib (que não entende var()/hex).
const rgbHex = (hex) => {
  const { r, g, b } = hexParaRgb(hex);
  return rgb(r / 255, g / 255, b / 255);
};

const generatePdfSeguro = async (proposta) => {
  const pdfDoc = await PDFDocument.create();
  const page = pdfDoc.addPage([595.28, 841.89]);

  // Logo da empresa configurada (antes fixa em 'logo.png', com bug de caminho relativo)
  const empresa = await getEmpresaAtual();
  let logoImage = null;
  if (empresa?.logoPrincipal) {
    try {
      const base64 = empresa.logoPrincipal.split(',')[1];
      const bin = atob(base64);
      const bytes = new Uint8Array(bin.length);
      for (let i = 0; i < bin.length; i += 1) bytes[i] = bin.charCodeAt(i);
      logoImage = await pdfDoc.embedPng(bytes);
    } catch (e) { /* sem logo */ }
  }
  const logoDims = logoImage ? logoImage.scale(0.5) : { width: 0, height: 0 }; // Redimensionar a logo pela metade

  // Calcular a posição centralizada horizontalmente
  const centerX = (page.getWidth() - logoDims.width) / 2;
  // Posicionar a logo a 100 pontos a partir do topo da página (ajuste conforme necessário)
  const marginTop = 50;
  const logoTop = page.getHeight() - logoDims.height - marginTop;

  const { width, height } = page.getSize();
  
  const regular = await pdfDoc.embedFont(StandardFonts.Helvetica);
  const bold = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

  const colors = {
    preto: rgb(0,0,0),
    branco: rgb (1,1,1),
    azul: rgbHex(coresHex.chumbo), // rebrand: era o azul Arasol, agora chumbo Marcki
    amareloclaro: rgbHex(coresHex.laranjaClaro), // rebrand: era dourado Arasol
    amareloescuro: rgbHex(coresHex.laranja), // rebrand: era dourado Arasol
  }

  const label = {
    size: 18,
    color: colors.azul,
    font: bold
  }

  const description = {
    size: 18,
    color: colors.preto,
  }

  let text;
  let textSize; 
  const centraliza = (text,textSize) => {
    const textWidth = bold.widthOfTextAtSize(text, textSize);
    const textX = (width - textWidth) / 2;
    return textX
  }

  inicializarIndicesSeguro()

  // ---------------------------------------- Pagina 1 -----------------------------------------------------------

  // Desenhar a logo na página
  if (logoImage) {
    page.drawImage(logoImage, {
      x: centerX,
      y: logoTop,
      width: logoDims.width,
      height: logoDims.height,
      align: 'center',
    });
  }


  text = 'Proposta Comercial de Seguro';
  textSize = 25
  page.drawText(text, {
    x: centraliza(text,textSize),
    y: height / 2 + 50,
    size: textSize,
    font: bold,
    color: rgbHex(coresHex.chumbo), // rebrand: era um azul Arasol hardcoded fora do objeto colors
  });

  page.drawText('Projeto: ', {
    x: width / 2 - 250,
    y: height / 2 - 50,
    ...label
  });
  
  page.drawText(proposta.cliente.nome, {
    x: width / 2 - 250 + bold.widthOfTextAtSize("Projeto: ",18),
    y: height / 2 - 50,
    ...description
  });

  page.drawText(`Data: `, {
    x: width / 2 + 80,
    y: height / 2 - 50,
    ...label
  });

  page.drawText(`${new Date(proposta.data).toLocaleDateString()}`, {
    x: width / 2 + 80 + bold.widthOfTextAtSize("Data: ",18),
    y: height / 2 - 50,
    ...description
  });

  page.drawText('Responsável Comercial: ', {
    x: width / 2 - 250,
    y: height / 2 - 100,
    ...label
  });

  page.drawText(proposta.user.nome, {
    x: width / 2 - 250 + bold.widthOfTextAtSize("Responsável Comercial: ",18),
    y: height / 2 - 100,
    ...description
  });

  const nomeLabel = `${empresa?.nome || 'ARASOL Energia Fotovoltaica'}: `;
  page.drawText(nomeLabel, {
    x: width / 2 - 250,
    y: height / 2 - 150,
    ...label
  });

  page.drawText(`(${proposta.user.telefone?.substring(0, 2)}) ${proposta.user.telefone?.substring(2)}`, {
    x: width / 2 - 250 + bold.widthOfTextAtSize(nomeLabel,18),
    y: height / 2 - 150,
    ...description
  });

  text = empresa?.nome || 'ARASOL Energia Fotovoltaica';
  textSize = 14
  page.drawText(text, {
    x: centraliza(text,textSize),
    y: 100,
    ...label,
    size: textSize
  });

  text = empresa?.endereco || 'Araguari - MG / Ribeirão Preto - SP';
  textSize = 14
  page.drawText(text, {
    x: centraliza(text,textSize),
    y: 75,
    ...label,
    size: textSize
  });

// ---------------------------------------- Pagina 2 -----------------------------------------------------------
  const page2 = pdfDoc.addPage([595.28, 841.89]);

  const headerHeight = 30
  page2.drawRectangle({
    x: 30,
    y: height - headerHeight - 30,
    width: width - 60,
    height: headerHeight,
    color: label.color, // Cor de fundo azul
  });

  const headerText = '1 | Descrição';
  page2.drawText(headerText, {
    x: 40,
    y: height - headerHeight - 20 ,
    size: 14,
    font: bold,
    color: rgb(1, 1, 1), // Cor de texto branca
  });
  // --
  const headerHeight5 = 20
  page2.drawRectangle({
    x: 30,
    y: height - 100,
    width: width - 60,
    height: headerHeight5,
    color: colors.amareloclaro, // Cor de fundo azul
  });
  text = 'Valor do Sistema:';
  textSize = 11
  page2.drawText(text, {
    x: 30,
    y: height - 95,
    size: textSize,
    color: colors.azul,
    font: bold
  });
  page2.drawLine({
    start: { x: 30, y: height - 100 },
    end: { x: width - 60 + 30, y: height - 100 },
    thickness: 2,
    color: colors.azul,
  })
  // --
  page2.drawRectangle({
    x: 30,
    y: height - 140,
    width: width - 60,
    height: 20,
    color: rgb(1, 1, 1), // Fundo branco
    borderColor: colors.azul, // Borda azul
    borderWidth: 1, // Largura da borda
  });
  text = `${parseFloat(proposta.valorprojeto).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`;
  textSize = 11
  page2.drawText(text, {
    x: 35,
    y: height - 135,
    size: textSize,
    color: colors.azul,
  });
  // --------------
  page2.drawRectangle({
    x: 30,
    y: height - 180,
    width: width - 60,
    height: headerHeight5,
    color: colors.amareloclaro, // Cor de fundo azul
  });
  page2.drawLine({
    start: { x: 30, y: height - 180 },
    end: { x: width - 60 + 30, y: height - 180 },
    thickness: 2,
    color: colors.azul,
  })
  text = 'Tempo de Cobertura';
  textSize = 11
  page2.drawText(text, {
    x: 30,
    y: height - 175,
    size: textSize,
    color: colors.azul,
    font: bold
  });
  text = 'À Vista';
  textSize = 11
  page2.drawText(text, {
    x: 180,
    y: height - 175,
    size: textSize,
    color: colors.azul,
    font: bold
  });
  text = '2 Vezes*';
  textSize = 11
  page2.drawText(text, {
    x: 280,
    y: height - 175,
    size: textSize,
    color: colors.azul,
    font: bold
  });
  text = '3 Vezes*';
  textSize = 11
  page2.drawText(text, {
    x: 390,
    y: height - 175,
    size: textSize,
    color: colors.azul,
    font: bold
  });
  text = '4 Vezes*';
  textSize = 11
  page2.drawText(text, {
    x: 500,
    y: height - 175,
    size: textSize,
    color: colors.azul,
    font: bold
  });
  // --
  page2.drawRectangle({
    x: 30,
    y: height - 200,
    width: 110,
    height: 20,
    color: rgb(1, 1, 1), // Fundo branco
    borderColor: colors.azul, // Borda azul
    borderWidth: 1, // Largura da borda
  });
  page2.drawRectangle({
    x: 140,
    y: height - 200,
    width: 110,
    height: 20,
    color: rgb(1, 1, 1), // Fundo branco
    borderColor: colors.azul, // Borda azul
    borderWidth: 1, // Largura da borda
  });
  page2.drawRectangle({
    x: 250,
    y: height - 200,
    width: 110,
    height: 20,
    color: rgb(1, 1, 1), // Fundo branco
    borderColor: colors.azul, // Borda azul
    borderWidth: 1, // Largura da borda
  });
  page2.drawRectangle({
    x: 360,
    y: height - 200,
    width: 105,
    height: 20,
    color: rgb(1, 1, 1), // Fundo branco
    borderColor: colors.azul, // Borda azul
    borderWidth: 1, // Largura da borda
  });
  page2.drawRectangle({
    x: 465,
    y: height - 200,
    width: 100,
    height: 20,
    color: rgb(1, 1, 1), // Fundo branco
    borderColor: colors.azul, // Borda azul
    borderWidth: 1, // Largura da borda
  });
  text = 'Seguro para 1 Ano';
  textSize = 11
  page2.drawText(text, {
    x: 35,
    y: height - 195,
    size: textSize,
    color: colors.azul,
  });
  text = `${parseFloat(calcularValoresSeguro(proposta.valorprojeto, 1, 1).valorParcela).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`;
  textSize = 11
  page2.drawText(text, {
    x: 145,
    y: height - 195,
    size: textSize,
    color: colors.azul,
  });
  text = `${parseFloat(calcularValoresSeguro(proposta.valorprojeto, 1, 2).valorParcela).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`;
  textSize = 11
  page2.drawText(text, {
    x: 255,
    y: height - 195,
    size: textSize,
    color: colors.azul,
  });
  text = `${parseFloat(calcularValoresSeguro(proposta.valorprojeto, 1, 3).valorParcela).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`;
  textSize = 11
  page2.drawText(text, {
    x: 365,
    y: height - 195,
    size: textSize,
    color: colors.azul,
  });
  text = `${parseFloat(calcularValoresSeguro(proposta.valorprojeto, 1, 4).valorParcela).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`;
  textSize = 11
  page2.drawText(text, {
    x: 470,
    y: height - 195,
    size: textSize,
    color: colors.azul,
  });
  // --
  // --
  page2.drawRectangle({
    x: 30,
    y: height - 220,
    width: 110,
    height: 20,
    color: rgb(1, 1, 1), // Fundo branco
    borderColor: colors.azul, // Borda azul
    borderWidth: 1, // Largura da borda
  });
  page2.drawRectangle({
    x: 140,
    y: height - 220,
    width: 110,
    height: 20,
    color: rgb(1, 1, 1), // Fundo branco
    borderColor: colors.azul, // Borda azul
    borderWidth: 1, // Largura da borda
  });
  page2.drawRectangle({
    x: 250,
    y: height - 220,
    width: 110,
    height: 20,
    color: rgb(1, 1, 1), // Fundo branco
    borderColor: colors.azul, // Borda azul
    borderWidth: 1, // Largura da borda
  });
  page2.drawRectangle({
    x: 360,
    y: height - 220,
    width: 105,
    height: 20,
    color: rgb(1, 1, 1), // Fundo branco
    borderColor: colors.azul, // Borda azul
    borderWidth: 1, // Largura da borda
  });
  page2.drawRectangle({
    x: 465,
    y: height - 220,
    width: 100,
    height: 20,
    color: rgb(1, 1, 1), // Fundo branco
    borderColor: colors.azul, // Borda azul
    borderWidth: 1, // Largura da borda
  });
  text = 'Seguro para 2 Anos';
  textSize = 11
  page2.drawText(text, {
    x: 35,
    y: height - 215,
    size: textSize,
    color: colors.azul,
  });
  text = `${parseFloat(calcularValoresSeguro(proposta.valorprojeto, 2, 1).valorParcela).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`;
  textSize = 11
  page2.drawText(text, {
    x: 145,
    y: height - 215,
    size: textSize,
    color: colors.azul,
  });
  text = `${parseFloat(calcularValoresSeguro(proposta.valorprojeto, 2, 2).valorParcela).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`;
  textSize = 11
  page2.drawText(text, {
    x: 255,
    y: height - 215,
    size: textSize,
    color: colors.azul,
  });
  text = `${parseFloat(calcularValoresSeguro(proposta.valorprojeto, 2, 3).valorParcela).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`;
  textSize = 11
  page2.drawText(text, {
    x: 365,
    y: height - 215,
    size: textSize,
    color: colors.azul,
  });
  text = `${parseFloat(calcularValoresSeguro(proposta.valorprojeto, 2, 4).valorParcela).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`;
  textSize = 11
  page2.drawText(text, {
    x: 470,
    y: height - 215,
    size: textSize,
    color: colors.azul,
  });
  // ----
  // --
  page2.drawRectangle({
    x: 30,
    y: height - 240,
    width: 110,
    height: 20,
    color: rgb(1, 1, 1), // Fundo branco
    borderColor: colors.azul, // Borda azul
    borderWidth: 1, // Largura da borda
  });
  page2.drawRectangle({
    x: 140,
    y: height - 240,
    width: 110,
    height: 20,
    color: rgb(1, 1, 1), // Fundo branco
    borderColor: colors.azul, // Borda azul
    borderWidth: 1, // Largura da borda
  });
  page2.drawRectangle({
    x: 250,
    y: height - 240,
    width: 110,
    height: 20,
    color: rgb(1, 1, 1), // Fundo branco
    borderColor: colors.azul, // Borda azul
    borderWidth: 1, // Largura da borda
  });
  page2.drawRectangle({
    x: 360,
    y: height - 240,
    width: 105,
    height: 20,
    color: rgb(1, 1, 1), // Fundo branco
    borderColor: colors.azul, // Borda azul
    borderWidth: 1, // Largura da borda
  });
  page2.drawRectangle({
    x: 465,
    y: height - 240,
    width: 100,
    height: 20,
    color: rgb(1, 1, 1), // Fundo branco
    borderColor: colors.azul, // Borda azul
    borderWidth: 1, // Largura da borda
  });
  text = 'Seguro para 3 Anos';
  textSize = 11
  page2.drawText(text, {
    x: 35,
    y: height - 235,
    size: textSize,
    color: colors.azul,
  });
  text = `${parseFloat(calcularValoresSeguro(proposta.valorprojeto, 3, 1).valorParcela).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`;
  textSize = 11
  page2.drawText(text, {
    x: 145,
    y: height - 235,
    size: textSize,
    color: colors.azul,
  });
  text = `${parseFloat(calcularValoresSeguro(proposta.valorprojeto, 3, 2).valorParcela).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`;
  textSize = 11
  page2.drawText(text, {
    x: 255,
    y: height - 235,
    size: textSize,
    color: colors.azul,
  });
  text = `${parseFloat(calcularValoresSeguro(proposta.valorprojeto, 3, 3).valorParcela).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`;
  textSize = 11
  page2.drawText(text, {
    x: 365,
    y: height - 235,
    size: textSize,
    color: colors.azul,
  });
  text = `${parseFloat(calcularValoresSeguro(proposta.valorprojeto, 3, 4).valorParcela).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`;
  textSize = 11
  page2.drawText(text, {
    x: 470,
    y: height - 235,
    size: textSize,
    color: colors.azul,
  });
  // ----
  // --
  page2.drawRectangle({
    x: 30,
    y: height - 260,
    width: 110,
    height: 20,
    color: rgb(1, 1, 1), // Fundo branco
    borderColor: colors.azul, // Borda azul
    borderWidth: 1, // Largura da borda
  });
  page2.drawRectangle({
    x: 140,
    y: height - 260,
    width: 110,
    height: 20,
    color: rgb(1, 1, 1), // Fundo branco
    borderColor: colors.azul, // Borda azul
    borderWidth: 1, // Largura da borda
  });
  page2.drawRectangle({
    x: 250,
    y: height - 260,
    width: 110,
    height: 20,
    color: rgb(1, 1, 1), // Fundo branco
    borderColor: colors.azul, // Borda azul
    borderWidth: 1, // Largura da borda
  });
  page2.drawRectangle({
    x: 360,
    y: height - 260,
    width: 105,
    height: 20,
    color: rgb(1, 1, 1), // Fundo branco
    borderColor: colors.azul, // Borda azul
    borderWidth: 1, // Largura da borda
  });
  page2.drawRectangle({
    x: 465,
    y: height - 260,
    width: 100,
    height: 20,
    color: rgb(1, 1, 1), // Fundo branco
    borderColor: colors.azul, // Borda azul
    borderWidth: 1, // Largura da borda
  });
  text = 'Seguro para 4 Anos';
  textSize = 11
  page2.drawText(text, {
    x: 35,
    y: height - 255,
    size: textSize,
    color: colors.azul,
  });
  text = `${parseFloat(calcularValoresSeguro(proposta.valorprojeto, 4, 1).valorParcela).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`;
  textSize = 11
  page2.drawText(text, {
    x: 145,
    y: height - 255,
    size: textSize,
    color: colors.azul,
  });
  text = `${parseFloat(calcularValoresSeguro(proposta.valorprojeto, 4, 2).valorParcela).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`;
  textSize = 11
  page2.drawText(text, {
    x: 255,
    y: height - 255,
    size: textSize,
    color: colors.azul,
  });
  text = `${parseFloat(calcularValoresSeguro(proposta.valorprojeto, 4, 3).valorParcela).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`;
  textSize = 11
  page2.drawText(text, {
    x: 365,
    y: height - 255,
    size: textSize,
    color: colors.azul,
  });
  text = `${parseFloat(calcularValoresSeguro(proposta.valorprojeto, 4, 4).valorParcela).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`;
  textSize = 11
  page2.drawText(text, {
    x: 470,
    y: height - 255,
    size: textSize,
    color: colors.azul,
  });
  // ----
  // --
  page2.drawRectangle({
    x: 30,
    y: height - 280,
    width: 110,
    height: 20,
    color: rgb(1, 1, 1), // Fundo branco
    borderColor: colors.azul, // Borda azul
    borderWidth: 1, // Largura da borda
  });
  page2.drawRectangle({
    x: 140,
    y: height - 280,
    width: 110,
    height: 20,
    color: rgb(1, 1, 1), // Fundo branco
    borderColor: colors.azul, // Borda azul
    borderWidth: 1, // Largura da borda
  });
  page2.drawRectangle({
    x: 250,
    y: height - 280,
    width: 110,
    height: 20,
    color: rgb(1, 1, 1), // Fundo branco
    borderColor: colors.azul, // Borda azul
    borderWidth: 1, // Largura da borda
  });
  page2.drawRectangle({
    x: 360,
    y: height - 280,
    width: 105,
    height: 20,
    color: rgb(1, 1, 1), // Fundo branco
    borderColor: colors.azul, // Borda azul
    borderWidth: 1, // Largura da borda
  });
  page2.drawRectangle({
    x: 465,
    y: height - 280,
    width: 100,
    height: 20,
    color: rgb(1, 1, 1), // Fundo branco
    borderColor: colors.azul, // Borda azul
    borderWidth: 1, // Largura da borda
  });
  text = 'Seguro para 5 Anos';
  textSize = 11
  page2.drawText(text, {
    x: 35,
    y: height - 275,
    size: textSize,
    color: colors.azul,
  });
  text = `${parseFloat(calcularValoresSeguro(proposta.valorprojeto, 5, 1).valorParcela).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`;
  textSize = 11
  page2.drawText(text, {
    x: 145,
    y: height - 275,
    size: textSize,
    color: colors.azul,
  });
  text = `${parseFloat(calcularValoresSeguro(proposta.valorprojeto, 5, 2).valorParcela).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`;
  textSize = 11
  page2.drawText(text, {
    x: 255,
    y: height - 275,
    size: textSize,
    color: colors.azul,
  });
  text = `${parseFloat(calcularValoresSeguro(proposta.valorprojeto, 5, 3).valorParcela).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`;
  textSize = 11
  page2.drawText(text, {
    x: 365,
    y: height - 275,
    size: textSize,
    color: colors.azul,
  });
  text = `${parseFloat(calcularValoresSeguro(proposta.valorprojeto, 5, 4).valorParcela).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`;
  textSize = 11
  page2.drawText(text, {
    x: 470,
    y: height - 275,
    size: textSize,
    color: colors.azul,
  });
  // ----
  
  // ----
  page2.drawText('* Valor da parcela', {
    x: 30,
    y: height - 289,
    size: 9,
    color: colors.azul,
  });
  // ----
  
  page2.drawRectangle({
    x: 30,
    y: height - headerHeight - 300,
    width: width - 60,
    height: headerHeight,
    color: label.color, // Cor de fundo azul
  });
  const headerText2 = '1 | Coberturas';
  page2.drawText(headerText2, {
    x: 40,
    y: height - headerHeight - 290 ,
    size: 14,
    font: bold,
    color: rgb(1, 1, 1), // Cor de texto branca
  });
  // ----
  text = 'O seguro orçado contempla as seguintes coberturas:';
  textSize = 11
  page2.drawText(text, {
    x: 35,
    y: height - 350,
    size: textSize,
    color: colors.azul,
  });
  
  page2.drawRectangle({
    x: 100,
    y: height - 400,
    width: 400,
    height: 20,
    color: rgb(1, 1, 1), // Fundo branco
    borderColor: colors.azul, // Borda azul
    borderWidth: 1, // Largura da borda
  });
  text = 'Incêndio';
  textSize = 11
  page2.drawText(text, {
    x: centraliza(text,textSize),
    y: height - 395,
    size: textSize,
    color: colors.azul,
    font: bold
  });
  page2.drawRectangle({
    x: 100,
    y: height - 420,
    width: 400,
    height: 20,
    color: rgb(1, 1, 1), // Fundo branco
    borderColor: colors.azul, // Borda azul
    borderWidth: 1, // Largura da borda
  });
  text = 'Explosão';
  textSize = 11
  page2.drawText(text, {
    x: centraliza(text,textSize),
    y: height - 415,
    size: textSize,
    color: colors.azul,
    font: bold
  });
  page2.drawRectangle({
    x: 100,
    y: height - 440,
    width: 400,
    height: 20,
    color: rgb(1, 1, 1), // Fundo branco
    borderColor: colors.azul, // Borda azul
    borderWidth: 1, // Largura da borda
  });
  text = 'Queda de Raio';
  textSize = 11
  page2.drawText(text, {
    x: centraliza(text,textSize),
    y: height - 435,
    size: textSize,
    color: colors.azul,
    font: bold
  });
  page2.drawRectangle({
    x: 100,
    y: height - 460,
    width: 400,
    height: 20,
    color: rgb(1, 1, 1), // Fundo branco
    borderColor: colors.azul, // Borda azul
    borderWidth: 1, // Largura da borda
  });
  text = 'Vendaval (Limitado a 50% do valor do projeto)';
  textSize = 11
  page2.drawText(text, {
    x: centraliza(text,textSize),
    y: height - 455,
    size: textSize,
    color: colors.azul,
    font: bold
  });
  page2.drawRectangle({
    x: 100,
    y: height - 480,
    width: 400,
    height: 20,
    color: rgb(1, 1, 1), // Fundo branco
    borderColor: colors.azul, // Borda azul
    borderWidth: 1, // Largura da borda
  });
  text = 'Granizo (Limitado a 50% do valor do projeto)';
  textSize = 11
  page2.drawText(text, {
    x: centraliza(text,textSize),
    y: height - 475,
    size: textSize,
    color: colors.azul,
    font: bold
  });
  page2.drawRectangle({
    x: 100,
    y: height - 500,
    width: 400,
    height: 20,
    color: rgb(1, 1, 1), // Fundo branco
    borderColor: colors.azul, // Borda azul
    borderWidth: 1, // Largura da borda
  });
  text = 'Furacão (Limitado a 50% do valor do projeto)';
  textSize = 11
  page2.drawText(text, {
    x: centraliza(text,textSize),
    y: height - 495,
    size: textSize,
    color: colors.azul,
    font: bold
  });
  page2.drawRectangle({
    x: 100,
    y: height - 520,
    width: 400,
    height: 20,
    color: rgb(1, 1, 1), // Fundo branco
    borderColor: colors.azul, // Borda azul
    borderWidth: 1, // Largura da borda
  });
  text = 'Ciclone (Limitado a 50% do valor do projeto)';
  textSize = 11
  page2.drawText(text, {
    x: centraliza(text,textSize),
    y: height - 515,
    size: textSize,
    color: colors.azul,
    font: bold
  });
  page2.drawRectangle({
    x: 100,
    y: height - 540,
    width: 400,
    height: 20,
    color: rgb(1, 1, 1), // Fundo branco
    borderColor: colors.azul, // Borda azul
    borderWidth: 1, // Largura da borda
  });
  text = 'Impacto de Veículos';
  textSize = 11
  page2.drawText(text, {
    x: centraliza(text,textSize),
    y: height - 535,
    size: textSize,
    color: colors.azul,
    font: bold
  });
  page2.drawRectangle({
    x: 100,
    y: height - 560,
    width: 400,
    height: 20,
    color: rgb(1, 1, 1), // Fundo branco
    borderColor: colors.azul, // Borda azul
    borderWidth: 1, // Largura da borda
  });
  text = 'Inundação';
  textSize = 11
  page2.drawText(text, {
    x: centraliza(text,textSize),
    y: height - 555,
    size: textSize,
    color: colors.azul,
    font: bold
  });
  page2.drawRectangle({
    x: 100,
    y: height - 580,
    width: 400,
    height: 20,
    color: rgb(1, 1, 1), // Fundo branco
    borderColor: colors.azul, // Borda azul
    borderWidth: 1, // Largura da borda
  });
  text = 'Alagamento';
  textSize = 11
  page2.drawText(text, {
    x: centraliza(text,textSize),
    y: height - 575,
    size: textSize,
    color: colors.azul,
    font: bold
  });
  page2.drawRectangle({
    x: 100,
    y: height - 600,
    width: 400,
    height: 20,
    color: rgb(1, 1, 1), // Fundo branco
    borderColor: colors.azul, // Borda azul
    borderWidth: 1, // Largura da borda
  });
  text = 'Roubo/Furto Qualificado (Limitado a 50% do valor do projeto)';
  textSize = 11
  page2.drawText(text, {
    x: centraliza(text,textSize),
    y: height - 596,
    size: textSize,
    color: colors.azul,
    font: bold
  });
  page2.drawRectangle({
    x: 100,
    y: height - 620,
    width: 400,
    height: 20,
    color: rgb(1, 1, 1), // Fundo branco
    borderColor: colors.azul, // Borda azul
    borderWidth: 1, // Largura da borda
  });
  text = 'Danos Elétricos (Limitado a 30% do valor do projeto)';
  textSize = 11
  page2.drawText(text, {
    x: centraliza(text,textSize),
    y: height - 615,
    size: textSize,
    color: colors.azul,
    font: bold
  });
  page2.drawRectangle({
    x: 100,
    y: height - 640,
    width: 400,
    height: 20,
    color: rgb(1, 1, 1), // Fundo branco
    borderColor: colors.azul, // Borda azul
    borderWidth: 1, // Largura da borda
  });
  text = 'Despesas Extras (Limitado a 5% do valor do projeto)';
  textSize = 11
  page2.drawText(text, {
    x: centraliza(text,textSize),
    y: height - 635,
    size: textSize,
    color: colors.azul,
    font: bold
  });
  // ---------------------------------------- Pagina 3 -----------------------------------------------------------
  const page3 = pdfDoc.addPage([595.28, 841.89]);

  page3.drawRectangle({
    x: 30,
    y: height - headerHeight - 30,
    width: width - 60,
    height: headerHeight,
    color: label.color, // Cor de fundo azul
  });
  const headerText3 = '2.1 | Documentos Necessários para Contratação ';
  page3.drawText(headerText3, {
    x: 40,
    y: height - headerHeight - 20 ,
    size: 14,
    font: bold,
    color: rgb(1, 1, 1), // Cor de texto branca
  });
  // ----
  // ----
  text = 'Para contratação são necessários:';
  textSize = 11
  page3.drawText(text, {
    x: 35,
    y: height - 80,
    size: textSize,
    color: colors.azul,
  });
  page3.drawRectangle({
    x: 100,
    y: height - 110,
    width: 400,
    height: 20,
    color: rgb(1, 1, 1), // Fundo branco
    borderColor: colors.azul, // Borda azul
    borderWidth: 1, // Largura da borda
  });
  text = 'Nota Fiscal';
  textSize = 11
  page3.drawText(text, {
    x: centraliza(text,textSize),
    y: height - 105,
    size: textSize,
    color: colors.azul,
    font: bold
  });
  page3.drawRectangle({
    x: 100,
    y: height - 130,
    width: 400,
    height: 20,
    color: rgb(1, 1, 1), // Fundo branco
    borderColor: colors.azul, // Borda azul
    borderWidth: 1, // Largura da borda
  });
  text = 'Comprovante de Endereço do local de Instalação';
  textSize = 11
  page3.drawText(text, {
    x: centraliza(text,textSize),
    y: height - 125,
    size: textSize,
    color: colors.azul,
    font: bold
  });
  page3.drawRectangle({
    x: 100,
    y: height - 150,
    width: 400,
    height: 20,
    color: rgb(1, 1, 1), // Fundo branco
    borderColor: colors.azul, // Borda azul
    borderWidth: 1, // Largura da borda
  });
  text = 'Documento do Titular da Nota Fiscal';
  textSize = 11
  page3.drawText(text, {
    x: centraliza(text,textSize),
    y: height - 145,
    size: textSize,
    color: colors.azul,
    font: bold
  });
  page3.drawRectangle({
    x: 100,
    y: height - 170,
    width: 400,
    height: 20,
    color: rgb(1, 1, 1), // Fundo branco
    borderColor: colors.azul, // Borda azul
    borderWidth: 1, // Largura da borda
  });
  text = 'Número de Telefone';
  textSize = 11
  page3.drawText(text, {
    x: centraliza(text,textSize),
    y: height - 165,
    size: textSize,
    color: colors.azul,
    font: bold
  });
  page3.drawRectangle({
    x: 100,
    y: height - 190,
    width: 400,
    height: 20,
    color: rgb(1, 1, 1), // Fundo branco
    borderColor: colors.azul, // Borda azul
    borderWidth: 1, // Largura da borda
  });
  text = 'Endereço de E-mail ';
  textSize = 11
  page3.drawText(text, {
    x: centraliza(text,textSize),
    y: height - 185,
    size: textSize,
    color: colors.azul,
    font: bold
  });
  // ---

  // --
  page3.drawText(`Opção escolhida:`, {
    x: 35,
    y: height - 210,
    size: textSize,
    color: colors.azul,
    font: bold
  });

  page3.drawText(`1 (  )    1 ano de seguro - ${parseFloat(calcularValoresSeguro(proposta.valorprojeto, 1, 1).valorParcela).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`, {
    x: 35,
    y: height - 230,
    size: textSize,
    color: colors.preto,
  });

  page3.drawText(`2 (  )    2 anos de seguro - ${parseFloat(calcularValoresSeguro(proposta.valorprojeto, 2, 1).valorParcela).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`, {
    x: 35,
    y: height - 250,
    size: textSize,
    color: colors.preto,
  });

  page3.drawText(`3 (  )    3 anos de seguro - ${parseFloat(calcularValoresSeguro(proposta.valorprojeto, 3, 1).valorParcela).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`, {
    x: 35,
    y: height - 270,
    size: textSize,
    color: colors.preto,
  });

  page3.drawText(`4 (  )    4 anos de seguro - ${parseFloat(calcularValoresSeguro(proposta.valorprojeto, 4, 1).valorParcela).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`, {
    x: 35,
    y: height - 290,
    size: textSize,
    color: colors.preto,
  });

  page3.drawText(`5 (  )    5 anos de seguro - ${parseFloat(calcularValoresSeguro(proposta.valorprojeto, 5, 1).valorParcela).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`, {
    x: 35,
    y: height - 310,
    size: textSize,
    color: colors.preto,
  });
  // --

  // -- Assinatura
  page3.drawLine({
    start: { x: 30, y: height - 450 },
    end: { x: 270, y: height - 450 },
    thickness: 1,
  })
  text = empresa?.razaoSocial || 'ARASOL Energia Fotovoltaica';
  textSize = 10
  page3.drawText(text, {
    x: 90,
    y: height - 460,
    size: textSize,
  });
  text = `CNPJ: ${empresa?.cnpj || '37.119.496/0001-27'}`;
  textSize = 10
  page3.drawText(text, {
    x: 95,
    y: height - 475,
    size: textSize,
  });
  page3.drawLine({
    start: { x: 320, y: height - 450 },
    end: { x: 560, y: height - 450 },
    thickness: 1,
  })
  text = `Cliente: ${proposta.cliente.nome}`;
  textSize = 10
  page3.drawText(text, {
    x: 330,
    y: height - 460,
    size: textSize,
  });
  text = `CPF/CNPJ: ${proposta.cliente.cpf}`;
  textSize = 10
  page3.drawText(text, {
    x: 330,
    y: height - 470,
    size: textSize,
  });
  // ---------------------------------------- Fim -----------------------------------------------------------

  // Gerar o PDF como um ArrayBuffer
  const pdfBytes = await pdfDoc.save();

  // Criar um Blob a partir do ArrayBuffer
  const pdfBlob = new Blob([pdfBytes], { type: 'application/pdf' });

  // Criar um objeto URL para o Blob
  const url = URL.createObjectURL(pdfBlob);

  // Criar um link e clicá-lo para fazer o download do PDF
  const link = document.createElement('a');
  link.href = url;
  link.download = `proposta_seguro_${proposta.cliente.nome.replace(/\s+/g, '_')}.pdf`;
  link.click();

  // Limpar o objeto URL após o download
  URL.revokeObjectURL(url);
  };

  export default generatePdfSeguro;